<section class="kpi-dashboard">
  <div class="kpi-dashboard__header">
    <h2>{{ 'myPortals.kpiDashboard.title' | translate }}</h2>
  </div>

  <div class="kpi-dashboard__frame">
    @if (dashboardLoading) {
      <div class="kpi-dashboard__skeleton"></div>
    }

    @if (dashboardError) {
      <div class="kpi-dashboard__error">
        <h3>{{ 'myPortals.kpiDashboard.errorTitle' | translate }}</h3>
        <p>{{ 'myPortals.kpiDashboard.errorMessage' | translate }}</p>
      </div>
    }

    @if (dashboardUrl && !dashboardError) {
      <iframe
        [src]="dashboardUrl"
        title="Dashboard de KPIs"
        (load)="onDashboardLoad()"
        (error)="onDashboardError()"></iframe>
    }
  </div>
</section>
